document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.badge-plus-form').forEach((form) => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();

      const addRes = await fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(form),
        headers: { 'Accept': 'application/json' }
      });
      if (!addRes.ok) throw new Error(await addRes.text());
      await addRes.json();

      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          updates: {},
          sections: ['cart-drawer','cart-icon-bubble']
        })
      })
        .then(r => r.json())
        .then((cart) => {
          document.querySelector('cart-drawer').renderContents(cart);
          document.querySelector('cart-drawer.drawer').classList.remove('is-empty');
        })
        .then(() => {
          const opener = document.getElementById('cart-icon-bubble');
          if (opener) {
            opener.click();
          } else {
            console.error('Quick-add: cart-icon-bubble not found');
          }
        })
        .catch((err) => {
          console.error('Quick-add drawer error:', err);
        });
    });
  });
});



